export const setOrmWidgetStatus = (value) => {
	return { type: "SET_ORM_WIDGET_STATUS", payload: value };
};
